import { ExternalAccount } from '../state/Radom'

const normalizedAccountType = (account: ExternalAccount): string => (account.accountType ?? '').toLowerCase()

export const isActiveExternalAccount = (account: ExternalAccount): boolean => account.active !== false

export const isCryptoExternalAccount = (account: ExternalAccount): boolean =>
  normalizedAccountType(account) === 'crypto' || !!account.crypto

export const isIbanExternalAccount = (account: ExternalAccount): boolean =>
  normalizedAccountType(account) === 'iban' || !!account.iban

export const isEurIbanExternalAccount = (account: ExternalAccount): boolean => {
  const currency = account.currency?.toUpperCase()
  return isActiveExternalAccount(account) &&
    isIbanExternalAccount(account) &&
    (!currency || currency === 'EUR')
}
